const BaseMap = (function() {
	const init = function(mapEl, options) {
		const map = LoadMap(mapEl, options);
		return map;
	}

	const LoadMap = function(mapEl, options) {
		const map = new google.maps.Map(document.querySelector(mapEl), options);
		return map;
	}

	return {
		init: init
	};
})();

export default BaseMap;